module.exports = "/_next/static/images/christopher-warren@3x-5cda782a23c51a420fa424a8656171eb.png";